import { UserInfo } from "./UserInfo";
import { wsConfirmDialog } from "./wsConfirmDialog";

export enum GenericDialogActions {
  SAVE_CHANGES = "SAVE_CHANGES",
  DISCARD_CHANGES = "DISCARD_CHANGES",
  DO_NOTHING = "DO_NOTHING",
}

export const unsavedChangesDialog = async (
  userInfo: UserInfo,
  headerText: string
) => {
  const r = await wsConfirmDialog({
    userInfo,
    header: headerText,
    message: userInfo.locStore
      .id("df829cbf8f7a")
      .loc("Du har ulagrede endringer"),
    icon: "pi pi-save",
    acceptLabel: userInfo.locStore.id("873b03cee413").loc("Lagre endringer"),
  });

  if (r === true) return GenericDialogActions.SAVE_CHANGES;
  if (r === false) return GenericDialogActions.DISCARD_CHANGES;
  return GenericDialogActions.DO_NOTHING;
};

export const invalidFieldsCannotBeSavedDialog = async (userInfo: UserInfo) => {
  const r = await wsConfirmDialog({
    userInfo,
    header: userInfo.locStore.id("bf1a55e3818c").loc("Kan ikke lagre"),
    message: userInfo.locStore
      .id("af3c4a5cba53")
      .loc("Ett eller flere felter har feil"),
    icon: "pi pi-times-circle",
    acceptLabel: userInfo.locStore.id("f9fd68c4fe39").loc("Fiks problemet"),
    rejectLabel: userInfo.locStore.id("035f0bae9e46").loc("Lukk skjema"),
  });

  if (r === true) return GenericDialogActions.DO_NOTHING;
  if (r === false) return GenericDialogActions.DISCARD_CHANGES;
  return GenericDialogActions.DO_NOTHING;
};
